import './ContactTagsPopup.scss';

import React from 'react';
import { connect } from 'react-redux';
import TagModel from '@mm/state/model/TagModel';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { AssignTagForm } from '../AssignTagForm/AssignTagForm';
import { Tag } from '../Tag/Tag';

type PropsFromState = ReturnType<typeof mapStateToProps>;
type PropsFromDispatch = {};

type OuterProps = {
  contactId: number;
  tags: TagModel[];
};

type Props = PropsFromState & PropsFromDispatch & OuterProps;

const ContactTagsPopupPure = ({ tags, fbPageId, contactId }: Props) => {
  return (
    <div className="contact-tags-popup">
      <div className="contact-tags-popup__tag-list">
        {tags &&
          tags.map(tag => (
            <Tag
              key={tag.name}
              item={tag}
              contactId={contactId}
              fbPageId={fbPageId}
            />
          ))}
      </div>
      <AssignTagForm tags={tags} contactId={contactId} fbPageId={fbPageId} />
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  fbPageId: activeFacebookPageIdSelector(state),
});

export const ContactTagsPopup = connect<
  PropsFromState,
  PropsFromDispatch,
  OuterProps
>(mapStateToProps)(ContactTagsPopupPure);
